import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const Branches = lazy(() => import('./branches'));

export function BranchesPage() {
  return (
    <article className="space-y-6" data-testid="branches-page">
      <Suspense fallback={<Loading />}>
        <Branches />
      </Suspense>
    </article>
  );
}
